'use client'

import TopReviewerSlider from '.'
import { useState, useRef, useCallback } from 'react'

const ReviewSlide = ({ initialReviews }) => {
  const [reviews, setReviews] = useState(initialReviews || [])
  const [nextPageToFetch, setNextPageToFetch] = useState(2)
  const [loadingMore, setLoadingMore] = useState(false)

  const loadedPages = useRef(new Set([1]))

  const loadPage = async (pageNumber) => {
    if (loadingMore) return
    if (loadedPages.current.has(pageNumber)) return

    setLoadingMore(true)

    const res = await fetch(`stays/api/reviews-data?page=${pageNumber}`)
    const json = await res.json()

    const list = json?.data?.results ?? json?.data?.data?.results ?? []

    if (list.length > 0) {
      setReviews((prev) => {
        const existingIds = new Set(prev.map((r) => r.id))
        const uniqueNew = list.filter((r) => !existingIds.has(r.id))
        return [...prev, ...uniqueNew]
      })

      loadedPages.current.add(pageNumber)
      setNextPageToFetch(pageNumber + 1)
    }

    setLoadingMore(false)
  }

  const handleSlideChange = useCallback(
    (index) => {
      const threshold = 3
      const itemsLoaded = reviews.length

      if (itemsLoaded > 0 && index >= itemsLoaded - threshold) {
        loadPage(nextPageToFetch)
      }
    },
    [reviews.length, nextPageToFetch],
  )

  return (
    <div style={{ minHeight: '400px' }}>
      <TopReviewerSlider
        cardDataNew={reviews}
        onSlideIndexChange={handleSlideChange}
      />
    </div>
  )
}

export default ReviewSlide
